import styled from 'styled-components'
import { ChevronIcon, colors, spacing, font } from '@chegg-ui/theme'
import { fanta } from '@chegg/fanta'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const Container = styled.div.attrs({
  role: 'region',
  'aria-label': 'Citation Search Input',
})`
  background-color: ${colors.white};
  padding: ${spacing.px16};
  border-color: ${colors.greyLight};
  border-style: solid;
  border-width: 2px;
`

export const InputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;

  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex-direction: column;
  }
`

export const SelectContainer = styled.div`
  flex-basis: 108px;

  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex-basis: auto;
    width: 100%;
    margin-bottom: 4px;
  }
`

export const ButtonText = styled.div`
  width: 76px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: ${font.lineHeight.xs};
`

export const SearchHelperLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${colors.link};
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  &:hover {
    text-decoration: underline;
  }
`

export const DropdownTrigger = styled.button<{ isOpen: boolean }>`
  position: relative;
  width: 100%;
  height: 40px;
  background: ${colors.white};
  border: 2px ${colors.greyLight} solid;
  border-right: 0;
  border-radius: 8px 0 0 8px;
  color: ${colors.dark};
  ${AspiraStack};
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    border-right: 2px ${colors.greyLight} solid;
    border-radius: 8px;
    justify-content: space-between;
    padding: 5px 0.875rem;

    > div {
      width: auto;
    }
  }
`

export const SearchLabel = styled.label`
  display: block;
  margin: ${fanta.spacing.xs} 0;
  color: ${colors.grey};
  ${AspiraStack};
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
`

export const Chevron = styled(ChevronIcon)`
  margin-top: ${spacing.px4};
`

export const BottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 20px;
`

export const SeparatorPipe = styled.span`
  padding-left: 1%;
  padding-right: 1%;
`

export const SearchHelperLeft = styled.div`
  flex-grow: 2;
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    text-align: center;
  }
`

export const WorldCatDesktop = styled.div`
  transform: translateY(-6px);
  padding-right: ${spacing.px24};
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    display: none;
  }
`

export const WorldCatSmall = styled.div`
  padding-bottom: ${spacing.px16};
  @media (min-width: ${({ theme }) => adjust(themeBreakPoints.small(theme), 1)}) {
    display: none;
  }
`
